import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button, Dialog, TextField } from '@unite-us/ui';
import EditButton from '../../common/EditButton';
import Spinner from '../../common/spinners/Spinner';
var HINT_TEXT = 'Notes appear throughout client records. Please avoid including sensitive information (including PHI) in your note.'; // eslint-disable-line max-len
var NOTE_PROMPT = 'Please ask the client if there are special instructions that should be followed when contacting them.'; // eslint-disable-line max-len

var ContactNotesEdit = function ContactNotesEdit(_ref) {
  var initialValues = _ref.initialValues,
    updateContactPreference = _ref.updateContactPreference;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var contactNotesModalRef = useRef(null);
  var openDialog = function openDialog() {
    contactNotesModalRef.current.openDialog();
  };
  var closeDialog = function closeDialog() {
    contactNotesModalRef.current.closeDialog();
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues, form) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            _context.next = 3;
            return updateContactPreference(formValues);
          case 3:
            setIsSubmitting(false);
            closeDialog();
            form.reset();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "contact-notes-edit"
  }, /*#__PURE__*/React.createElement(EditButton, {
    edit: openDialog,
    labelText: "Edit",
    id: "contact-notes-edit-btn",
    "aria-label": "edit contact notes"
  }), /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        submitting = _ref3.submitting;
      return /*#__PURE__*/React.createElement(Dialog, {
        id: "edit-contact-notes-modal",
        onCloseModal: closeDialog,
        onRequestClose: closeDialog,
        ref: contactNotesModalRef,
        title: "Edit Contact Notes",
        type: "form",
        actions: [/*#__PURE__*/React.createElement(Button, {
          id: "edit-contact-notes-btn",
          onClick: closeDialog,
          disabled: submitting,
          label: "Cancel"
        }), /*#__PURE__*/React.createElement(Button, {
          id: "edit-contact-notes-save-btn",
          onClick: handleSubmit,
          disabled: submitting,
          label: "Save",
          primary: true
        })]
      }, /*#__PURE__*/React.createElement("div", {
        className: "min-h-full"
      }, isSubmitting ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(Field, {
        name: "contact_notes",
        parse: function parse(val) {
          return val;
        }
      }, function (props) {
        return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
          afterLabelContent: NOTE_PROMPT,
          hint: HINT_TEXT,
          id: "contact-requirements-notes",
          inline: false,
          label: "Contact Notes"
        }));
      })));
    }
  }));
};
ContactNotesEdit.propTypes = {
  initialValues: PropTypes.object.isRequired,
  updateContactPreference: PropTypes.func.isRequired
};
export default ContactNotesEdit;
//# sourceMappingURL=ContactNotesEdit.js.map